<template>
  <w-setting-sliding-popup ref="slidingPopup" title="사용자 정보 엑셀 수정" width="550px">
    <div slot="content">
      <el-form :model="formData" ref="formData">
        <div class="title-h3 mr-r15 mr-b10">엑셀 파일 등록</div>
        <el-row>
          <span style="color: #47C7B8;">※ 사용자 목록 엑셀출력 파일을 수정 후 해당 파일을 업로드 해주시길 바랍니다.</span>
        </el-row>
        <el-row class="mr-b10">
          <span style="color: #47C7B8;">※ 파일의 내용이 엑셀 형식에 맞지 않는 경우, 정보가 정상적으로 수정되지 않습니다.</span>
        </el-row>
        <el-input disabled style="width: 79%; float: left; margin-right: 5px;" v-model="fileList.name"></el-input>
        <el-upload action="" :auto-upload="false" :show-file-list="false" :before-upload="(file) => file"
          accept :on-change="changeUploadFile" ref="reportUpload">
          <el-button type="primary" size="medium" style="margin-right: 5px; width: 100%;">파일업로드</el-button>
        </el-upload>
      </el-form>
    </div>
    <div slot="footer" class="btn-group-center">
      <el-button size="large" type="solid" @click="onClickExcelImport" :disabled="!disabledFlag">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import UserSettingAPI from '@/api/settings/user/user-setting';

export default {
  name: 'WImportExcelAccountSettingPopup',
  data() {
    return {
      fileList: {},
      disabledFlag: false,
      formData: {},
    };
  },
  methods: {
    open() {
      this.fileList = {};
      this.disabledFlag = false;
      this.$refs.slidingPopup.open();
    },
    changeUploadFile(item) {
      this.fileList = item.raw;
      this.disabledFlag = true;
    },
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    onClickExcelImport() {
      const data = new FormData();
      if (this.fileList.uid) {
        data.append('files', this.fileList);
      }
      // 엑셀 입력
      UserSettingAPI.importUserList(data).then((res) => {
        if (res.data.success) {
          this.$emit('reload-data');
          this.clickCloseBtn();
          const resultData = res.data.data;
          let message = '';
          if (resultData.failCnt === 0) {
            message = `${resultData.totalCnt}개의 사용자 정보를 수정하였습니다.`;
          } else {
            message = `${resultData.totalCnt}개의 사용자 정보를 수정하였습니다. 실패(${resultData.failCnt}/${resultData.totalCnt})`;
          }
          this.$message(msgUtil.getCustomResultMsgData(message, true));
        } else {
          // this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '엑셀 입력', false));
          this.$message(msgUtil.getCustomResultMsgData(`${res.data.message}`, false));
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/popup/ImportExcelAccountSettingPopup.vue